import { render, staticRenderFns } from "./productInspectionStyle.vue?vue&type=template&id=313232ab&scoped=true"
import script from "./productInspectionStyle.vue?vue&type=script&lang=js"
export * from "./productInspectionStyle.vue?vue&type=script&lang=js"
import style0 from "./productInspectionStyle.vue?vue&type=style&index=0&id=313232ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313232ab",
  null
  
)

export default component.exports